"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconEditSection = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.fill");

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IconEditSection =
/*#__PURE__*/
function (_Component) {
  _inherits(IconEditSection, _Component);

  function IconEditSection() {
    _classCallCheck(this, IconEditSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconEditSection).apply(this, arguments));
  }

  _createClass(IconEditSection, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("svg", {
        className: "edit-section",
        x: "0px",
        y: "0px",
        width: this.props.width ? this.props.width : "45px",
        viewBox: "0 0 1000 1000",
        enableBackground: "0 0 1000 1000",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react.default.createElement("rect", {
        x: "158",
        y: "304",
        fill: "#FFF",
        strokeMiterlimit: "10",
        width: "436",
        height: "399"
      }), this.props.isClosing ? _react.default.createElement("path", {
        fill: this.props.fill ? this.props.fill : "#000",
        d: "M379.318,132.208c-194.157,0-355.33,163.644-355.33,359.888s161.173,359.888,355.33,359.888 c42.962,0,213.011-0.984,571.915-359.888C592.329,133.192,422.28,132.208,379.318,132.208z M527.73,451.989v71.963l-311.841,0 v-71.963L527.73,451.989z"
      }) : _react.default.createElement("path", {
        fill: this.props.fill ? this.props.fill : "#000",
        d: "M379.318,132.208c-194.157,0-355.33,163.644-355.33,359.888s161.173,359.888,355.33,359.888 c42.962,0,213.011-0.984,571.915-359.888C592.329,133.192,422.28,132.208,379.318,132.208z M407.791,523.952V643.89h-71.963V523.952 H215.889v-71.963h119.939V332.05h71.963v119.939H527.73v71.963H407.791z"
      }));
    }
  }]);

  return IconEditSection;
}(_react.Component);

exports.IconEditSection = IconEditSection;
//# sourceMappingURL=IconEditSection.js.map